import {Component} from '@angular/core';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem
} from '@ng-bootstrap/ng-bootstrap/accordion';
import {NgOptimizedImage} from '@angular/common';
import {Constants} from "../../constants";

@Component({
  selector: 'app-about-me-section',
  templateUrl: './about-me-section.component.html',
  styleUrls: ['./about-me-section.component.scss'],
  imports: [NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionButton, NgbAccordionCollapse, NgbAccordionBody, NgOptimizedImage]
})
export class AboutMeSectionComponent {

  protected readonly company = Constants.Company;
  protected readonly profileImage = Constants.Website.ProfileImage;

}
